<template>
  <v-main class="main-content bg-black mb-view background-custom" :style="{ '--bg-url': `url(${bgImage})` }">
    <v-fade-transition mode="out-in">
      <router-view class="mb-in-view" />
    </v-fade-transition>
  </v-main>
</template>

<script>
export default {
  name: 'BaseView',
  data() {
    return {
      bgImage: require(process.env.VUE_APP_BG),
    };
  },
}
</script>
<style>
.background-custom {
  background: var(--bg-url) no-repeat center center/cover !important;
}
.main-content {
  padding: 0px 0px 0px !important;
}

.mb-in-view {
  width: 550px !important;
}

.v-main__wrap {
  display: flex;
  justify-content: center;
}

.v-window__container,
.theme--light.v-tabs-items {
  background: transparent !important;
  transition: unset !important;
}

@media only screen and (max-width: 600px) {
  .mb-in-view {
    width: 100% !important;
  }
}
</style>
